module.exports = __webpack_public_path__ + "media/images/new_landing/people/tomas-dundacek-8ea07b8a0bd1634e803cdb9844f34587.jpeg";